var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.19 13.56H5.7a1.73 1.73 0 0 0-1.08.4v-2.29a9.59 9.59 0 0 1 2.77-6.75 1 1 0 0 0 0-1.37A1 1 0 0 0 6 3.56a11.57 11.57 0 0 0-3.32 8.11V15a1 1 0 0 0-.91 1v4.63a1.47 1.47 0 0 0 1.48 1.47H4a1.69 1.69 0 0 0 1.7 1.47h1.49c.94 0 1.704-.76 1.71-1.7v-6.6a1.72 1.72 0 0 0-1.71-1.71zM3.71 17H4v3.19h-.29V17zM7 21.63H6V15.5h1v6.13zm22.49-6.92v-3A11.74 11.74 0 0 0 17.7 0h-1.55a11.66 11.66 0 0 0-5 1.1 1 1 0 0 0-.48 1.29 1 1 0 0 0 1.33.47 9.79 9.79 0 0 1 4.16-.92h1.54c5.405-.028 9.811 4.325 9.85 9.73v2.72a1.7 1.7 0 0 0-1.62-1.19h-1.49c-.94 0-1.704.76-1.71 1.7v6.6c.006.94.77 1.7 1.71 1.7h1.49c.216 0 .43-.04.63-.12A9.8 9.8 0 0 1 21.07 28a1 1 0 0 0-.95-.86h-2.48a2.36 2.36 0 0 0-1.72.71A2.43 2.43 0 0 0 17.64 32h2.48a1 1 0 0 0 1-1v-1a11.7 11.7 0 0 0 8-8.36 1.48 1.48 0 0 0 1.1-1.42v-4.59a1 1 0 0 0-.73-.92zm-3.79 6.55h-1v-6.12h1v6.12zm-6.55 8.8h-1.51a.52.52 0 0 1-.51-.5.47.47 0 0 1 .16-.35.5.5 0 0 1 .35-.14h1.51v.99zm9.14-10.26H28v-3.2h.28l.01 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M23.088 24.407a.97.97 0 0 0-.97.97v2.91a.776.776 0 0 1-.775.775H2.715a.776.776 0 0 1-.776-.776V8.601h2.813a2.133 2.133 0 0 0 2.133-2.133v-3.54h14.448c.429 0 .776.348.776.776v2.347a.97.97 0 0 0 1.94 0V3.704A2.725 2.725 0 0 0 21.332.99H5.48L0 7.273v21.023a2.725 2.725 0 0 0 2.715 2.715h18.618a2.725 2.725 0 0 0 2.715-2.715v-2.91a.97.97 0 0 0-.96-.979zM4.752 6.662H3.103l1.842-2.114v1.94a.194.194 0 0 1-.193.174zm24.989.397a3.345 3.345 0 0 0-2.783-.63c-.99.207-1.874.76-2.493 1.561l-9.697 12.422-.562 4.422a1.57 1.57 0 0 0 1.571 1.804 1.58 1.58 0 0 0 .66-.136l3.927-1.687 9.697-12.403c.645-.79.989-1.783.97-2.802a3.404 3.404 0 0 0-1.29-2.55zm-1.164 4.15L19.19 23.225l-3.006 1.26.427-3.296 9.377-11.976c.333-.438.81-.744 1.348-.863a1.406 1.406 0 0 1 1.755 1.358 2.288 2.288 0 0 1-.514 1.503zM4.451 23.506a.97.97 0 1 0 0 1.94h7.641a.97.97 0 0 0 0-1.94H4.451z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M28.9 6.37H1.1a.75.75 0 0 1 0-1.5h8.35v-.9A3.73 3.73 0 0 1 13.18.25h3.64a3.73 3.73 0 0 1 3.73 3.72v.91h8.35a.75.75 0 0 1 0 1.5v-.01zM11 4.88h8.1v-.9a2.23 2.23 0 0 0-2.23-2.22h-3.69A2.23 2.23 0 0 0 11 3.97v.91zm10.12 28.87H8.88a3.74 3.74 0 0 1-3.71-3.43L3.54 9.88a.74.74 0 0 1 .69-.8.76.76 0 0 1 .81.68l1.62 20.4a2.24 2.24 0 0 0 2.22 2h12.24a2.24 2.24 0 0 0 2.22-2.06L25 9.8a.76.76 0 0 1 1.323-.425.74.74 0 0 1 .177.545l-1.67 20.39a3.74 3.74 0 0 1-3.71 3.44zM12 29.51a.76.76 0 0 1-.75-.74l-.32-17.89a.75.75 0 0 1 .73-.76.72.72 0 0 1 .77.73l.36 17.9a.76.76 0 0 1-.73.77l-.06-.01zm6 0a.76.76 0 0 1-.73-.77l.3-17.86a.75.75 0 0 1 .75-.73c.41.01.736.35.73.76l-.36 17.9a.76.76 0 0 1-.69.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#231F20",
    fillRule: "nonzero",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9-7h48v48H-9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.086156eb92c8a158f718562514a3c5b3.svg";
export { ForwardRef as ReactComponent };